import { Component, ViewEncapsulation } from '@angular/core';
import { UIBlockingService } from '../core/ui-blocking.service';
import { merge, Observable } from 'rxjs';
import { MemberDiscountService } from './member-discount.service';
import { ToastNotificationService } from '../core/toast-notification.service';
import { DumbPendingDiscount } from './DTOs/dumb-pending-discount';
import { GetPendingDiscountsListRequest } from './DTOs/get-pending-discounts-list-request';
import { GetPendingNewsListRequest } from '../pending-news/DTOs/get-pending-news-list-request';
import { PendingDiscountsDtRetInfo } from './DTOs/pending-discounts-dt-ret-info';
import { Data } from '@angular/router';
import da from '@mobiscroll/angular/dist/js/i18n/da';
import {CommonLibrary} from "../core/common-library";

@Component({
  selector: 'app-pending-discounts-list',
  templateUrl: './pending-discounts-list.component.html',
    encapsulation: ViewEncapsulation.None,
    providers: [UIBlockingService]
  
})
export class PendingDiscountsListComponent {
    constructor(private memberDiscountService: MemberDiscountService,
        private notificationService: ToastNotificationService,
        private blockUI: UIBlockingService) { }

    pendingDiscounts: DumbPendingDiscount[] = [];
    totalDiscounts = 0;
    filteredDiscounts = 0;
    pageNum = 1;
    itemsPerPage = 10;
    initialLoad = true;
    filtersChanged = false;
    searchText = "";

    sortType = 5;
    keywordSearches: string[] = [];
    statusSearch = { display: "Pending", value: 0 };

    changeStatusSearch(toChange: number) {
        if (this.statusSearch.value == toChange)
            return;

        this.filtersChanged = true;
        switch (toChange) {
            case 1:
                this.statusSearch = { display: "All", value: -1 };
                break;
            case 2:
                this.statusSearch = { display: "Pending", value: 0 };
                break;
            case 3:
                this.statusSearch = { display: "Active", value: 3 };
                break;
            case 4:
                this.statusSearch = { display: "Expired", value: 4 };
                break;
            case 5:
                this.statusSearch = { display: "Denied", value: 2 };
                break;
            default:
                this.statusSearch = { display: "Pending", value: 0 };
                break;
        }
        this.getPendingDiscounts();
    }

    get currentPageNum() { return this.pageNum };
    set currentPageNum(page: number) {
        this.pageNum = page;
        if (!this.initialLoad)
            this.getPendingDiscounts();
    }

    get itemStart() {
        return ((this.currentPageNum - 1) * this.itemsPerPage) + 1;
    }
    get itemEnd() {
        return ((this.currentPageNum - 1) * this.itemsPerPage) + this.pendingDiscounts.length;
    }

    ngOnInit() {
        var observablesMerged = merge(this.getPendingDiscountsObservable());
        this.blockUI.start();
        observablesMerged.subscribe(
            {
                next: (data) => {
                    this.pendingDiscounts = data.data;
                    this.totalDiscounts = data.recordsTotal;
                    this.filteredDiscounts = data.recordsFiltered;
                    this.initialLoad = false;
                },
                error: (err) => {
                    this.notificationService.error(err.error.message);
                    this.blockUI.stop();
                    console.log(err)
                },
                complete: () => {
                    this.blockUI.stop();
                    if (this.pendingDiscounts.length == 0) {
                        console.log(" no Discounts found ")
                    }
                }
            });
    }

    getPendingDiscounts() {
        this.blockUI.start();
        this.getPendingDiscountsObservable()
            .subscribe(
                {
                    next: (data) => {
                        this.pendingDiscounts = data.data;
                        this.totalDiscounts = data.recordsTotal;
                        this.filteredDiscounts = data.recordsFiltered;
                    },
                    error: (err) => {
                        this.notificationService.error(err.error.message);
                        this.blockUI.stop();
                        console.log(err)
                    },
                    complete: () => {
                        this.blockUI.stop();
                        if (this.pendingDiscounts.length == 0) {
                            console.log(" no Discounts found ")
                        }
                    }
                });
    }

    getPendingDiscountsObservable(): Observable<PendingDiscountsDtRetInfo> {
        var req = this.createSearchRequest();
        return this.memberDiscountService
            .getPendingDiscountsList(req);
    }

    createSearchRequest(): GetPendingDiscountsListRequest {
        var req = new GetPendingDiscountsListRequest();

        if (this.filtersChanged)
            this.pageNum = 1;

        req.PageNumber = this.pageNum - 1; //to get the 0-indexed number
        req.ItemsPerPage = this.itemsPerPage;

        req.KeywordSearches = this.keywordSearches;
        req.Sorting = this.sortType;

        req.StatusSort = this.statusSearch.value;

        this.filtersChanged = false;

        return req;
    }

    getDateFormat(startDate: Date, endDate: Date) {
        var endDateString = CommonLibrary.formatDateIntoString(endDate);
        var startDateString = CommonLibrary.formatDateIntoString(startDate);
        var hasPassed = this.hasStartDatePassed(startDateString);
        if (!startDate && !endDate) return "No dates given";
        if (!endDate && !hasPassed) return `Starts ${startDateString}`;
        if (!endDate && hasPassed) return `Started ${startDateString}`
        if (!startDate || hasPassed) return `Ends ${endDateString}`;
        return `${startDateString} until ${endDateString}`;
    }

    hasStartDatePassed(date: string): boolean {
        const inputDate = new Date(date);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return inputDate <= today;
    }

    enterSearchTerm(event: any) {
        if (event.keyCode != 13)//13 is enter, 32 is space
            return;

        this.searchText.trim().split(' ').forEach((term) => this.keywordSearches.push(term));
        this.searchText = '';
        this.filtersChanged = true;
        this.getPendingDiscounts();
        return;
    }

    removeSearchTerm(term: string) {
        var index = this.keywordSearches.indexOf(term);
        if (index != -1) {
            this.keywordSearches.splice(index, 1);
            this.filtersChanged = true;
        }
        this.getPendingDiscounts();
    }

    clearSearch() {
        this.searchText = "";
        this.sortType = 1;
        this.keywordSearches = [];
        this.filtersChanged = true;
        this.statusSearch = { display: "Pending", value: 0 };
        this.getPendingDiscounts();
    }
    hitSearchBtn() {
        this.searchText.trim().split(' ').forEach((term) => this.keywordSearches.push(term));
        this.searchText = '';
        this.filtersChanged = true;
        this.getPendingDiscounts();
    }


    changeSortType(column: number) {
        switch (column) {
            case 1:
                this.sortType = (this.sortType == 1) ? 2 : 1;
                break;
            case 2:
                this.sortType = (this.sortType == 3) ? 4 : 3;
                break;
            case 3:
                this.sortType = (this.sortType == 5) ? 6 : 5;
                break;
            case 4:
                this.sortType = (this.sortType == 7) ? 8 : 7;
                break;
            case 5:
                this.sortType = (this.sortType == 9) ? 10 : 9;
                break;
            default:
                break;
        }
        this.getPendingDiscounts();
    }
}
